import logoFull from '@/assets/brand/logo-demaxtore-full.png';
import logoCompact from '@/assets/brand/logo-demaxtore-compact.png';
import logoMark from '@/assets/brand/logo-demaxtore-mark.png';

/**
 * DeMaxtore brand mark.
 * @param {'full'|'compact'|'mark'} variant — mark: sidebar; full: ship/plane wordmark (transparent PNG); compact: legacy
 * @param {'default'|'dark'} theme — dark: light backgrounds on navy panels (watermark / hero)
 * @param {'default'|'watermark'} display — watermark: large faint background on auth panels
 * @param {string} [className] — wrapper classes
 */
export default function BrandLogo({
  variant = 'full',
  theme = 'default',
  display = 'default',
  className = '',
  alt = 'DeMaxtore',
}) {
  const onDark = theme === 'dark';
  const isMark = variant === 'mark';
  const isFull = variant === 'full';
  const isWatermark = display === 'watermark';
  const useCompact = variant === 'compact' && !onDark;
  const src = isMark ? logoMark : useCompact ? logoCompact : logoFull;

  const imgClass = isWatermark
    ? 'w-[min(92%,520px)] max-h-[min(42vh,280px)] object-contain opacity-[0.14]'
    : isMark
      ? 'h-9 w-auto max-w-full object-contain object-left'
      : isFull
        ? onDark
          ? 'h-14 w-auto max-w-full object-contain sm:h-16'
          : 'h-[3.25rem] w-auto max-w-full object-contain object-left sm:h-[3.75rem]'
        : 'h-8 w-auto max-w-full object-contain object-left';

  if (isWatermark) {
    return (
      <div
        className={`pointer-events-none absolute inset-0 flex items-center justify-center ${className}`}
        aria-hidden
        data-testid="brand-logo-watermark"
      >
        <img src={logoFull} alt="" className={imgClass} decoding="async" />
      </div>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center ${onDark || isFull ? 'w-full' : ''} ${className}`}
      data-testid="brand-logo"
    >
      <img src={src} alt={alt} className={imgClass} decoding="async" />
    </span>
  );
}
